import Store from '../../../store'
import Press from './press.vue'
import API from './api'

Store.registerModule('press', {
  namespaced: true,
  state: {
    query: '',
    category: '',
    total: 0,
    current: 1,
    results: [],
    numberOfResults: 0
  },
  mutations: {
    filter(state, request) {
      API.search({
        SearchTerm: request.query || '',
        CurrentPage: 1,
        Categories: request.category ? [request.category] : [],
      }).then(data => Object.assign(state, {
        query: request.query,
        total: data.NumberOfPages,
        current: 1,
        category: request.category,
        results: data.results,
        numberOfResults: data.NumberOfResults
      }))
    },
    paginate(state, current) {
      API.search({
        SearchTerm: state.query,
        CurrentPage: current,
        Categories: [state.category],
      }).then(data => Object.assign(state, {
        current,
        results: data.results,
        numberOfResults: data.NumberOfResults
      }))
    }
  }
})
export default Press
